/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SortLabelColumnToggle extends Component {
  getSortName = value => value.replace(/-/g, '');

  getRevertSelectedSortName = () => {
    const name = this.getSortName(this.props.selectedValue);
    return this.hasDescType(this.props.selectedValue) ? `${name}` : `-${name}`;
  };
  hasDescType = value => value.includes('-');
  equalSortNames = () =>
    this.getSortName(this.props.defaultValue) ===
    this.getSortName(this.props.selectedValue);

  handleChange = e => {
    e.preventDefault();
    if (this.equalSortNames()) {
      this.props.handleChangeSortValue(this.getRevertSelectedSortName());
    } else {
      this.props.handleChangeSortValue(this.props.defaultValue);
    }
  };

  render() {
    const Tag = `${this.props.tag}`;
    let sortClass = '';
    if (this.equalSortNames()) {
      sortClass = this.hasDescType(this.props.selectedValue)
        ? this.props.descClassName
        : this.props.ascClassName;
    }
    return (
      <Tag
        className={`${this.props.className} ${sortClass}`}
        onClick={this.handleChange}
      >
        <a
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: this.props.label
          }}
        />
      </Tag>
    );
  }
}

SortLabelColumnToggle.defaultProps = {
  tag: 'div',
  selectedValue: '',
  sortName: '',
  className: '',
  ascClassName: 'sorting-dsc',
  descClassName: 'sorting-asc'
};

SortLabelColumnToggle.propTypes = {
  tag: PropTypes.string,
  className: PropTypes.string,
  ascClassName: PropTypes.string,
  descClassName: PropTypes.string,
  defaultValue: PropTypes.string.isRequired,
  selectedValue: PropTypes.string,
  label: PropTypes.string.isRequired,
  handleChangeSortValue: PropTypes.func.isRequired
};

export default SortLabelColumnToggle;



// WEBPACK FOOTER //
// ./src/components/Common/Inputs/SortLabelColumnToggle/SortLabelColumnToggle.js